import { useForm, useWatch, Controller } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux';

import { 
    Paper, 
    Stack, 
    TextField, 
    Typography 
} from '@mui/material'

import { Encabezado } from '../../Components/Encabezado/Encabezado'

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { FaFileExcel } from 'react-icons/fa6';
import { useEffect } from 'react';

import Loading from '../../Components/Modals/Loading/Loader';

import {
    fetchCambiarSuccess,
    fetchGetControlMensajeriaReport,
    selectIsLoading, 
    selectIsSuccess, 
    selectMessage 
} from '../../redux/ControlMensajeria/ControlMensajerioSlice';

import swal from 'sweetalert';

export const ControlMensajeriaReporte = () => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-SELECTOR
    const message = useSelector(selectMessage);
    const isLoading = useSelector(selectIsLoading);
    const isSuccess = useSelector(selectIsSuccess);

    // * FUNCION PARA REFRESCAR SUCCESS
    const refreshSuccess = () => dispatch(fetchCambiarSuccess());

    // ? HOOK-FORM
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm({
        defaultValues: {
            filtro: {
                fechaInicio: new Date(),
                fechaFin: new Date()
            }
        }
    });

    // ? HOOK-WATCH
    const filtro = useWatch({
        control,
        name: 'filtro'
    })

    // ? HOOK-EFFECT PARA LAS ALERTAS
    useEffect(() => {
        
        if(isSuccess === 'success' && message.length > 0){
            swal({title: 'Exitoso', text: message, icon: 'success'});
            reset();
            refreshSuccess();
        }
        else if(isSuccess === 'error'){
            swal({title: 'Error', text: message, icon: 'error'});
            refreshSuccess();
        }
    
    }, [isSuccess])

    // * FUNCION PARA ENVIAR DATA A BACK-END.
    const sendData = ( { filtro }) => {
        dispatch(fetchGetControlMensajeriaReport(filtro))
    }

  return (
    <Encabezado title='Reporte de Control de Mensajería'>
        <Stack className="form-group" width={'50%'}>
            <Paper>
                <Stack p={3} component='form' onSubmit={handleSubmit(sendData)}>
                    <Stack mb={4}>
                        <Typography fontWeight='bold'>Fecha de Inicio</Typography>
                        <Controller
                        control={control}
                        name="filtro.fechaInicio"
                        render={({ field }) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                            inputFormat='dd/MM/yyyy'
                            mask="__/__/____"
                            value={field.value}
                            onChange={(e) => field.onChange(e)}
                            renderInput={(params) => (
                                <TextField
                                height={10}
                                className="form-control"
                                style={{ height: 10 }}
                                {...params}
                                />
                            )}
                            />
                        </LocalizationProvider>
                        )}
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.filtro?.fechaInicio?.message}>
                            {errors.filtro?.fechaInicio?.message}
                        </Typography>
                    </Stack>

                    <Stack mt={2} mb={4}>
                        <Typography fontWeight='bold'>Fecha Término</Typography>
                        <Controller
                        control={control}
                        name="filtro.fechaFin"
                        render={({ field }) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                            minDate={filtro.fechaInicio}
                            inputFormat='dd/MM/yyyy'
                            mask="__/__/____"
                            value={field.value}
                            onChange={(e) => field.onChange(e)}
                            renderInput={(params) => (
                                <TextField
                                height={10}
                                className="form-control"
                                style={{ height: 10 }}
                                {...params}
                                />
                            )}
                            />
                        </LocalizationProvider>
                        )}
                        />

                        <Typography fontSize={14} className="text-danger" hidden={!errors.filtro?.fechaFin?.message}>
                            {errors.filtro?.fechaFin?.message}
                        </Typography>

                    </Stack>

                    <Stack mt={2}>
                        <div className='d-flex justify-content-end'>
                            <button className='btn btn-success'>Generar Reporte <FaFileExcel style={{marginLeft: 3, marginTop: -2}} fontSize={22} /> </button>
                        </div>
                    </Stack>

                </Stack>
            </Paper>
        </Stack>

        <Loading open={isLoading} />
    </Encabezado>
  )
}
